import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { deleteCustomer } from "../../api/apiCustomers";
import parseError from "../../utils/parseError";

export const useDeleteCustomer = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteCustomerMutate, isPending: isDeleting } = useMutation({
        mutationFn: deleteCustomer,
        onSuccess: (res) => {
            toast.success(res.message || "Customer deleted");
            queryClient.invalidateQueries(["customers"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to delete customer");
        },
    });

    return { deleteCustomerMutate, isDeleting };
};
